import React, { useState, useEffect } from 'react';
import Leftbar from './../components/Leftbar';
import Topbar from './../components/Topbar';
import { Link } from 'react-router-dom';
import TopNav from '../components/TopNav';
import { connect } from 'react-redux';
import { toggleLoader } from '../actions/loader';
import config from "../config/config";
import axios from "axios";
import { getLiveListing, displayError, displaySuccess, liveActive } from '../Utils/utils'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import SweetAlert from 'react-bootstrap-sweetalert';
import { Translate, I18n } from "react-redux-i18n";
import Alert from 'react-bootstrap/Alert'

const Live = (props) => {
  const [live, setLive] = useState([]);
  const [tempVarId, setTempVarId] = useState('');
  const [is_delete, setIsDelete] = useState(false);
  const [is_active, setIsActive] = useState(0);


  useEffect(async () => {
    props.toggleLoader(true);
    var getLive_var = await getLiveListing();
    console.log(getLive_var);
    setLive(getLive_var);
    props.toggleLoader(false);
  }, [])

  const deleteLive = async () => {
    var token = localStorage.getItem('token');
    props.toggleLoader(true);
    let path = config.siteUrl;
    axios.get(path + "/product/livecontent/delete/" + tempVarId, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    })
      .then(async (response) => {
        // props.toggleLoader(false);
        displaySuccess('Deleted Successfully');
        // props.toggleLoader(true);
        var getLive_var = await getLiveListing();
        setLive(getLive_var);
        props.toggleLoader(false);
      })
      .catch(function (error) {
        props.toggleLoader(false);
        if (error.response.status === 401) {
          window.location.href = '/';
        }
        displayError(error);
      });
  }
  const activeLive = async (id, is_active) => {
    props.toggleLoader(true);
    if (is_active === 1) {
      var active_var = await liveActive(id, 0);
    }
    else {
      var active_var = await liveActive(id, 1);
    }
    console.log(active_var);
    setIsActive(active_var);
    var getLive_var = await getLiveListing();
    setLive(getLive_var);
    props.toggleLoader(false);
  }

  return (
    <>
      <body id="page-top">
        <TopNav />
        <div id="wrapper">

          <Leftbar />

          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">

              <Topbar />

              <div className="container-fluid">
                <div className="row justify-content-between mb-3">
                  <div className="col">
                    <h1 className="h3 mb-0 title-top">{I18n.t('Live')}</h1>
                  </div>

                  <div className="col-auto ml-auto d-none d-sm-inline-block d-block d-sm-none">
                    <div className="form-row">
                      <div className="col-auto">
                        <Link to="/live-new">
                          <a className=" btn btn-light">
                            <i className="fas fa-plus fa-sm" /> {I18n.t('New Live Event')}</a></Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="card">

                      <div className="card-body">
                        <div className="table-responsive">
                          <Table className="table align-items-center mb-0">
                            <Thead>
                              <Tr>
                                <Th>{I18n.t('S no.')}</Th>
                                <Th>{I18n.t('Title')}</Th>
                                <Th>{I18n.t('Launch Date / Time')}</Th>
                                <Th>{I18n.t('Status')}</Th>
                                <Th>{I18n.t('Action')} </Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {(live.length === 0) ? <Tr>
                                <Td colspan="7" style={{ textAlign: 'center' }}>
                                  <Alert key={'alert'} variant={'info'}>
                                    {I18n.t('No live event')}
                                  </Alert>
                                </Td>
                              </Tr> : ''}
                              {live.map((list, index) => (
                                <Tr>
                                  <Td>{++index}</Td>
                                  <Td>{list.title} </Td>
                                  <Td>{list.launch_date_time}</Td>
                                  <td>
                                    {(list.is_active === 1) ?
                                      <span className='text-success'> {I18n.t('Active')} </span>
                                      : <span className='text-danger'> {I18n.t('Inactive')} </span>}
                                  </td>
                                  <Td>
                                    <div className>
                                      <Link to={'/edit-live/' + list.id}title={I18n.t("Edit")}>
                                        <a className="items-center m-1 btn-outline-dark btn btn-sm">
                                          {<i className="far fa-edit"></i> /* {I18n.t('Edit')} */}
                                        </a>
                                      </Link>
                                      <button className="flex items-center btn btn-sm  btn-outline-danger"
                                        onClick={e => {
                                          setTempVarId(list.id)
                                          setIsDelete(true)
                                        }}title={I18n.t("Delete")}>
                                        <i className="far fa-trash-alt" /> </button>
                                      <a className="flex items-center m-1 btn-outline-primary btn btn-sm" href
                                        onClick={e => { activeLive(list.id, list.is_active) }}>
                                        {(list.is_active === 0) ?
                                          <i className="fas fa-play"title={I18n.t("Inactive")} /> : <i className="fa fa-pause" title={I18n.t("Active")}/>}
                                      </a>
                                    </div>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        </div>
                      </div>
                      {is_delete === true ? (
                        <SweetAlert
                          warning
                          showCancel
                          confirmBtnText="Yes"
                          confirmBtnBsStyle="danger"
                          title={I18n.t('Are you sure?')}
                          onConfirm={(e) => {
                            deleteLive()
                            setIsDelete(false)
                            // window.location.reload(false)
                          }}
                          onCancel={(e) => {
                            setIsDelete(false)
                            setTempVarId('')
                          }}
                          focusCancelBtn
                        >
                          {I18n.t('Do you want to delete this offer?')}
                        </SweetAlert>
                      ) : ([]
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = (state) => {
  return {
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Live);